const getCSVDeatils = (fs: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader()
    fileReader.onload = (event: ProgressEvent<FileReader>) => {
      const csvOutput = event.target?.result as string
      resolve(csvOutput)
    }
    fileReader.onerror = error => {
      reject(error)
    }
    if (fs) {
      fileReader.readAsText(fs)
    } else {
      reject('No file provided')
    }
  })
}

export const createInstantPaper = async (uploadedData: any, paperRequestDetails: any, userId: string) => {
  try {
    const uploadQuestionDetails = uploadedData.target.files[0]
    //Extracting CSV values
    const csvDetails = await getCSVDeatils(uploadQuestionDetails)
    if (!csvDetails) {
      return false
    }
    const requestToCreateInstantPaper = await fetch(`${process.env.REACT_APP_BACKEND_URL}/create-instant-paper`, {
    // const requestToCreateInstantPaper = await fetch(`http://localhost:3001/create-instant-paper`, {
      method: 'POST',
      body: JSON.stringify({ csvData: csvDetails, paperRequestDetails, userId }),
      headers: { 'Content-Type': 'application/json', charset: 'utf-8', 'Cache-Control': 'no-cache', Pragma: 'no-cache' },
    })
    if (requestToCreateInstantPaper.status === 201 || requestToCreateInstantPaper.status === 200) {
      if (requestToCreateInstantPaper.status === 201) {
        return { status: true, message: 'Paper created!' }
      }
      const responsne = await requestToCreateInstantPaper.json()
      if (responsne.reusableSections) {
        const reusableSubsections = responsne.questionsWithSubsections.map((subSections: any) => subSections.reusableSubsection)
        console.log(reusableSubsections, 'Subsections are this')
      }
    }
    return false
  } catch (err) {
    console.log(err, 'Error')
    return false
  }
}

export const fillQuestionsFromAnotherSubsections = async (reusableSectionDetails: any, paperRequestDetails: any, userId: string) => {
  try {
    const requestToCreateInstantPaper = await fetch(`${process.env.REACT_APP_BACKEND_URL}/create-paper/subsections`, {
    // const requestToCreateInstantPaper = await fetch(`http://localhost:3001/create-paper/subsections`, {
      method: 'POST',
      body: JSON.stringify({ selectedSubsectionDetails: reusableSectionDetails, paperRequestDetails, userId }),
      headers: { 'Content-Type': 'application/json', charset: 'utf-8' },
    })
    if (requestToCreateInstantPaper.status === 201) {
      return { status: true, message: 'Paper created!' }
    }
    return false
  } catch (err: any) {
    console.log(err, 'Error message')
    return false
  }
}

export const getAvailableSectionDetails = async (paperRequestDetails: any) => {
  try {
    console.log(process.env.REACT_APP_BACKEND_URL,'env')
    const requestToCreateInstantPaper: any = await fetch(`${process.env.REACT_APP_BACKEND_URL}/get-section-details`, {
    // const requestToCreateInstantPaper: any = await fetch(`http://localhost:3001/get-section-details`, {
      method: 'POST',
      body: JSON.stringify({ paperRequestDetails }),
      headers: { 'Content-Type': 'application/json', charset: 'utf-8' },
    })
    if (requestToCreateInstantPaper) {
      const response = await requestToCreateInstantPaper.json()
      if (response && response?.details) {
        return response?.details
      }
    }

    return false
  } catch (err) {
    console.log(err)
    return false
  }
}
